function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
import "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";
import { html as m } from "../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";
import "../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";
import { customElement as h } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/custom-element.js";
import { state as p } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/state.js";
import v from "../../../packages/web-components/src/components/avatar/gator/avatar.gator.scss.js";
import f from "../../../packages/web-components/src/components/avatar/avatar.tokens.scss.js";
import u from "../../../packages/web-components/src/tokens/primitive.tokens.scss.js";
import g from "../../../packages/web-components/src/tokens/semantic.tokens.scss.js";
import { NjcAvatar as x } from "../avatar.js";
import { createRef as z, ref as _ } from "../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/directives/ref.js";
import { ifDefined as d } from "../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/directives/if-defined.js";
import { unsafeCSS as i } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/css-tag.js";
var $ = Object.defineProperty,
  y = Object.getOwnPropertyDescriptor,
  c = function c(e, t, r, a) {
    for (var s = a > 1 ? void 0 : a ? y(t, r) : t, l = e.length - 1, n; l >= 0; l--) (n = e[l]) && (s = (a ? n(t, r, s) : n(s)) || s);
    return a && s && $(t, r, s), s;
  };
var o = /*#__PURE__*/function (_x) {
  function o() {
    var _this;
    _classCallCheck(this, o);
    _this = _callSuper(this, o, arguments), _this._avatarRef = z(), _this._size = 40;
    return _this;
  }
  _inherits(o, _x);
  return _createClass(o, [{
    key: "render",
    value: function render() {
      return this.skeleton ? m(_templateObject || (_templateObject = _taggedTemplateLiteral(["<ngc-skeleton-loader width=\"", "\" height=\"", "\" radius=\"50\"></ngc-skeleton-loader>"])), this.pixelSize, this.pixelSize) : m(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n                <div ", "\n                    class=\"gator-avatar ", "\"\n                    tabindex=\"", "\"\n                    role=\"", "\"\n                    aria-label=\"", "\"\n                    >\n                    <span class=\"gator-avatar-content\">\n                        <slot></slot>\n                        ", "\n                    </span>\n                </div>\n            "])), _(this._avatarRef), this.interactive ? "gator-avatar-interactive" : "", d(this.interactive ? "0" : void 0), this.interactive ? "button" : "img", this.srcAriaLabel || this.avatarAriaLabel, this.src ? m(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n                            <span class=\"gator-avatar-image\"></span>\n                        "]))) : null);
    }
  }, {
    key: "updated",
    value: function updated() {
      var e;
      if (this._avatarRef.value && (this.size && (this._size = this.pixelSize, this._avatarRef.value.style.width = "".concat(this._size, "px"), this._avatarRef.value.style.height = "".concat(this._size, "px"), (e = this._avatarRef.value.querySelector(".gator-avatar-content")) == null || e.setAttribute("style", "font-size: ".concat(this._size / 2.5, "px")), this.applySizeToSlottedIcon()), this.src)) {
        var t = this._avatarRef.value.querySelector(".gator-avatar-image");
        t && (t.style.backgroundImage = "url(".concat(this.src, ")"), t.style.width = "".concat(this._size, "px"), t.style.height = "".concat(this._size, "px"));
      }
    }
  }, {
    key: "applySizeToSlottedIcon",
    value: function applySizeToSlottedIcon() {
      var _this2 = this;
      var t;
      var e = (t = this._avatarRef.value) == null ? void 0 : t.querySelector("slot");
      e && e.assignedElements().forEach(function (a) {
        a.tagName.toLowerCase() === "ngc-icon" && (a.size = _this2.size === "xxx-small" ? "xx-small" : _this2.size);
      });
    }
  }, {
    key: "pixelSize",
    get: function get() {
      var e = parseInt(this.size);
      if (!Number.isNaN(e)) return e;
      switch (this.size) {
        case "xxx-small":
          return 16;
        case "xx-small":
          return 24;
        case "x-small":
          return 32;
        case "small":
          return 40;
        case "medium":
          return 48;
        case "large":
          return 64;
        case "x-large":
          return 80;
        default:
          return 40;
      }
    }
  }]);
}(x);
o.styles = [i(v), i(u), i(g), i(f)];
c([p()], o.prototype, "_size", 2);
o = c([h("ngc-avatar")], o);
export { o as NgcAvatar };